import {
  transformExportParamsToCrudApi,
  transformParamsToCrudApi,
} from '@app/core/crud/listing-adapter';
import { convertGetManyResponse } from '@app/core/crud/response-converter';
import { ListView } from '@app/core/list-view/ListView';
import { ListViewExportParams, ListViewQueryParams } from '@app/core/list-view/types';
import { auditReports, auditReportsApiClient } from '@mi-front/api-clients';
import { Paginated } from '@mi-front/core';
import { AodRulesList } from './AodRulesList';
import { CreateRuleButton } from './CreateRuleButton';
import { AOD_RULES_FILTERS_CONFIG } from './filter-config';

export function AodRulesListPage_v2() {
  const queryFn = async (
    params: ListViewQueryParams,
  ): Promise<Paginated<auditReports.AodRule> | ArrayBuffer> => {
    const processedParams = transformParamsToCrudApi(params);

    const response = await auditReports.getManyBaseAodRulesControllerAodRule(processedParams);
    return await convertGetManyResponse(response);
  };

  const exportFn = async (params: ListViewExportParams) => {
    return auditReportsApiClient({
      method: 'GET',
      url: `/aod-rules/export`,
      params: transformExportParamsToCrudApi(params),
      responseType: 'arraybuffer',
    });
  };

  return (
    <ListView
      listId="AodRulesList-v2"
      queryFn={queryFn}
      exportFn={exportFn}
      filters={AOD_RULES_FILTERS_CONFIG}
      actions={[<CreateRuleButton key="create-rule" />]}
      ListComponent={AodRulesList}
    />
  );
}
